import { LogLevel } from '../app/log/log-level.enum';

export const environment = {
    production: false,

    api_service_auth: "/api/auth",
    api_service_auth_google: "/api/auth/google",
    api_service_auth_registeradmin: "/api/auth/register/admin",
    api_service_client: "/api/clients",
    api_service_societies: "/api/societies",
    api_service_society: "/api/societies",
    api_service_department: "/api/departments",
    api_service_contact: "/api/contacts",
    api_service_profiles: "/api/profiles",
    api_service_system: "/api/systems",
    api_service_subsystem: "/api/subsystems",
    api_service_technology: "/api/technologies",
    api_service_types: "/api/types",
    api_service_users: "/api/users",
    api_service_project: "/api/projects",
    api_service_estimation: "/api/estimations",
    api_service_requirement: "/api/requirements",
    api_service_task: "/api/tasks",
    api_service_role: "/api/roles",
    api_service_gpt: "/api/gpt/query",
    api_service_ragpt: "/api/ragpt/queryRAGPT",
    api_service_metrics: "/api/metrics",
    api_service_createProjectRAG: "/api/ragpt/createProjectRAG",
    api_service_party_role: "/api/party-role-assignments",
    api_service_refresh_token: "/api/auth/refresh-token",
    api_service_permissions: "/api/auth/me/permissions",
    api_service_tenant: "/api/tenants",
    api_service_logs: "/api/logs/client",
    api_service_dashboard_metrics: "/api/dashboard/metrics",
    api_service_exports:      '/api/exports',
    api_service_integrations: '/api/integrations',
    api_service_estimations:  '/api/estimations'
  };